import { debounce } from "@/lobby_common/utils/index.js";
export default {
  name: "PopupDialog",
  data() {
    return {
      fullscreenFlag: false,
    };
  },
  props: {
    width: {
      type: [String, Number],
      default: "50%",
    },
    iddialog: {
      type: [String, Number],
      default: "",
    },
    dataOpt: {
      type: [Object],
      default: () => ({
        title: null,
      }),
    },
    show: {
      type: Boolean,
      default: false,
    },
    views: {
      type: [String, Number],
      default: "Login",
    },
    fullscreen: {
      type: Boolean,
      default: false,
    },
    top: {
      type: String,
      default: "15vh",
    },
    className: {
      type: String,
      default: "",
    },
    lockScroll: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    iddialogbox: {
      get() {
        return this.iddialog;
      },
      set(val) {
        return val;
      },
    },
  },
  mounted() {
    this.commonSySize();
    this.resizeHandler = debounce(() => {
      this.commonSySize();
    }, 300);
  },
  methods: {
    commonSySize() {
      const idTag = document.body;
      if (idTag?.offsetWidth < 768) {
        this.fullscreenFlag = true;
        // console.log(this.fullscreenFlag);
      } else {
        this.fullscreenFlag = false;
      }
    },
    close(event) {
      this.$emit("close", false);
      if (event) {
        event.stopPropagation();
        event.preventDefault();
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeHandler);
  },
};
